// Module
var code = "<remote-paged-grid-layout title-label-code=\"'jobs.validator'\" new-entity-label-code=\"'new.job.validator'\" columns=\"columns\" find-page=\"findPage\" sort-info=\"sortInfo\"> </remote-paged-grid-layout> ";
// Exports
export default code;